<template>
  <div class="notice">
    <div class="text">
      <slot></slot>
    </div>
    <icon v-if="closable" class="close" name="cross" @click="close"/>
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      default: 'info',
    },
    closable: {
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.notice {
  background: $c-gray;
  color: $c-text-mid;
  font-weight: 600;
  margin-bottom: 1rem;
  padding: 1rem;
  position: relative;
  text-align: center;
  > .close {
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
  a {
    text-decoration: underline;
  }

  // theme
  &.danger {
    background: $c-danger-light;
    color: $c-danger;
  }
  &.info {
    background: $c-info-light;
    color: $c-info;
  }
  &.neutral {
    background: $c-neutral-light;
    color: $c-neutral;
  }
  &.warning {
    background: $c-warning-light;
    color: $c-warning-dark;
  }
  &.success {
    background: $c-success-light;
    color: $c-success-dark;
  }

  // size
  &.sm {
    font-size: $h6;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Notice.vue